import { i18n, inject, pr, React, RouteComponentProps, ui } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { MessageScreen } from "../../common/MessageScreen";
import { CardTanSettingsRoutes } from "./CardTanSettingsRoutes";
import { CardTanSettingsStore } from "./CardTanSettingsStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: CardTanSettingsStore;
}

@inject("externalInterfaceStore")
export class CardTanSettingsCardsSuccess extends React.Component<RouteComponentProps<{}> & IProps> {
    render() {
        return (
            <MessageScreen
                useWebVersion
                variant="success"
                icon={pr.IconMessageOk}
                title={ui.__("cardTanSettings.debitCards.success.title")}
                messageComponent={<i18n.FormattedHTMLMessage id="cardTanSettings.debitCards.success.message" />}
                buttonLabelId="common.close"
                onDismiss={async () => {
                    pushRoute(CardTanSettingsRoutes.ROOT);
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsCardsSuccess.tsx